/** Human labels for material-change fields (stale reasons, refresh diffs). */
const REASON_LABELS: Record<string, string> = {
  'line.base_quantity': 'Buy quantities',
  'line.store_count': 'Store counts',
  'line.sku_number': 'SKU numbers',
  'line.case_pack': 'Case packs',
  'line.inner_pack': 'Inner packs',
  'line.set': 'Added or removed lines',
  population: 'Stores / DCs',
  'population.dc_codes': 'DC codes',
  'population.store_allocation': 'Store model allocation %',
  'line.moq': 'MOQ',
  'line.moa': 'MOA',
  'line.plan_sku_num': 'Plan SKU #',
  'line.sku_level': 'SKU levels (Parent / Child)',
  'line.pog_set_qty': 'POG set quantities',
  'line.unit_cost': 'Unit costs',
  'line.unit_qty_per_piab': 'Units per display',
  'line.ap_piab_purchase_qty': 'PIAB quantities',
  'line.parent_line_ref_id': 'PIAB families',
  'line.vendor_id': 'Vendors',
  'line.vendor_code': 'Vendors',
  'line.vendor_name': 'Vendors',
  'header.set_reset_date': 'Set date',
  'header.exit_date': 'Exit date',
  'header.seasonal_calendar_event_id': 'Seasonal calendar',
  'header.calendar_event_id': 'Calendar',
}

export const staleReasonLabel = (reason: string) =>
  REASON_LABELS[reason] ?? reason
